import { Seo } from "@/seo/Seo";
import { PageHero } from "@/layouts/PageHero";
import { Section } from "@/components/common/Section";
import { Container } from "@/components/common/Container";
import { Reveal } from "@/components/common/Reveal";
import { LeadForm } from "@/forms/LeadForm";
import { siteConfig } from "@/config/site.config";
import { Mail, Phone, MapPin, Check } from "@/icons";

const highlights = [
  "Direct communication throughout your project",
  "A clear scope, timeline and estimate within 48 hours",
  "No obligation, no pressure, no jargon",
];

const contactDetails = [
  { icon: Mail, label: "Email", value: siteConfig.contact.email },
  { icon: Phone, label: "Phone", value: siteConfig.contact.phone },
  { icon: MapPin, label: "Based in", value: siteConfig.contact.address },
];

export default function Contact() {
  return (
    <>
      <Seo
        title="Contact"
        description="Talk to VibeWell about AI automation, enterprise software and digital transformation. Tell us what you're trying to improve and we'll help identify the right solution."
        path="/contact"
      />
      <PageHero
        eyebrow="Start a conversation"
        titleLines={["Let's build what's", "next for your business."]}
        description="Tell us what you're trying to improve, automate or build. We'll explore the opportunity and recommend the right path forward."
      />

      <Section spacing="compact" className="pt-0">
        <Container>
          <div className="grid gap-12 lg:grid-cols-[0.85fr_1.15fr] lg:gap-16">
            <div className="flex flex-col gap-10">
              <Reveal>
                <ul className="space-y-4">
                  {highlights.map((item) => (
                    <li key={item} className="flex items-start gap-3">
                      <span className="mt-0.5 inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
                        <Check className="h-3 w-3" />
                      </span>
                      <span className="text-foreground">{item}</span>
                    </li>
                  ))}
                </ul>
              </Reveal>

              <Reveal delay={0.1}>
                <div className="space-y-5 rounded-2xl border border-border bg-card p-6">
                  {contactDetails.map(({ icon: Icon, label, value }) => (
                    <div key={label} className="flex items-center gap-4">
                      <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-primary/10 text-primary">
                        <Icon className="h-4 w-4" />
                      </span>
                      <div>
                        <p className="text-xs uppercase tracking-[0.12em] text-muted-foreground">
                          {label}
                        </p>
                        <p className="font-medium text-foreground">{value}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </Reveal>
            </div>

            <Reveal delay={0.05}>
              <LeadForm />
            </Reveal>
          </div>
        </Container>
      </Section>
    </>
  );
}
